export const RESET_STORE = 'RESET_STORE';